export default function getTimezone(): string | undefined {
  // SSR 环境（如 Next.js 服务端）不提供时区信息
  if (typeof window === 'undefined' || typeof Intl === 'undefined') {
    return undefined;
  }

  let tz: string | undefined;

  // 1. 使用 Intl（最稳定方式）
  try {
    tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch {
    tz = undefined;
  }

  // 2. Intl 返回无效值
  if (!tz || typeof tz !== 'string') {
    return undefined;
  }

  // 3. 过滤一些浏览器可能返回的异常值
  const invalids = new Set(['Etc/Unknown', '', 'UTC', null as any, undefined as any]);

  if (invalids.has(tz)) {
    return undefined;
  }

  return tz;
}
